import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './Shsat.scss';
import { getSHSResults } from '../../actions/student';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { withRtl } from '../../components/hoc';

const localMessages = defineMessages({
  shsatDashboardLink: {
    id: 'shsatresult.shsatDashboardLink',
    defaultMessage: 'Dashboard',
    description: 'Dashboard link',
  },
  shsatPageHeading: {
    id: 'shsatresult.shsatPageHeading',
    defaultMessage: 'Specialized High Schools Admissions Test (SHSAT) Results For {studentName}',
    description: 'Main heading for SHS result page',
    values: {
      studentName: 'You',
    },
  },
  shsatViewSubmittedButton: {
    id: 'shsatresult.shsatViewSubmittedButton',
    defaultMessage: 'VIEW SUBMITTED APPLICATION',
    description: 'VIEW SUBMITTED APPLICATION'
  }, 
  shsatDownloadLetterButton: {
    id: 'shsatresult.shsatDownloadLetterButton',
    defaultMessage: 'Download SHSAT Results Letter',
    description: 'Button text for download letter'
  },
  shsatNextStep: {
    id: 'shsatresult.shsatNextStep',
    defaultMessage: 'Next Steps',
    description: 'Text for next step in page'
  },
  shsatPageHelpText: {
    id: 'shsatresult.shsatPageHelpText',
    defaultMessage: 'Below you can find any offers from SPECIALIZED HIGH SCHOOLS for all admissions rounds you participated in that have returned results so far.',
    description: 'Text for SHSAT page help'
  },
  shsatScoreComposite: {
    id: 'shsatresult.shsatScoreComposite',
    defaultMessage: 'Composite Score :',
    description: 'Score text'
  },
  shsatScoreVerbal: {
    id: 'shsatresult.shsatScoreVerbal',
    defaultMessage: 'Verbal Score :',
    description: 'Score text'
  },
  shsatScoreMath: {
    id: 'shsatresult.shsatScoreMath',
    defaultMessage: 'Math Score :',
    description: 'Score text'
  },
  shsatOfferedGrade: {
    id: 'shsatresult.shsatOfferedGrade',
    defaultMessage: 'Offered Grade :',
    description: 'Offer text'
  },
  shsatOfferHeading: {
    id: 'shsatresult.shsatOfferHeading',
    defaultMessage: 'You have an offer to {schoolName}',
    description: 'Offer heading',
    values: {
      studentName: '',
    },
  },
  shsatNoOfferHeading: {
    id: 'shsatresult.shsatNoOfferHeading',
    defaultMessage: 'You did not receive an offer to any of the testing Specialized High Schools listed on your SHSAT registration.',
    description: 'No Offer heading'
  },
});

class Shsat extends Component {
  static propTypes = {
    error: PropTypes.shape({
      name: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      stack: PropTypes.string.isRequired,
      applicationId: PropTypes.string,
    }),

    dispatch: PropTypes.func.isRequired
  };

  static defaultProps = {
    error: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      result: {},
      student_data: {},
      appId: PropTypes.string
    };
  }

  setPage = () => {
    const { dispatch } = this.props;
    dispatch(setPage('up'));
    dispatch(getSchoolsPrograms());
  };

  componentDidMount() {
    const { user, dispatch } = this.props;
    const { applicationId } = user;
    let params = new URLSearchParams(window.location.search);
    let student_id = params.get('studentid');
    const getSHSResultTask = dispatch(getSHSResults(student_id)).catch(error => {
      console.error('Failed to getSHSResults', error);
    });

    Promise.all([
      getSHSResultTask
    ])
      .then(() => {
        this.setState({
          ...this.state,
          loaded: true,
          appId: applicationId,
          result: this.props.user.resultInfo.studentInfo.results[0],
          student_data: this.props.user.resultInfo.studentInfo.results[0].student
        });
      })
      .catch(error => {
        console.error('Error', error);
      });
  }

  render() {

    const { loaded, result, student_data, appId } = this.state;
    let locale = window.App.state.intl.locale;
    function titleCase(str) {
      return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase());
    }
    
    return (
      <div>
        <div className="breadcrumb" style={{ paddingLeft: "159px" }}>
          <i className="icon-caret-left"></i>
          <a href={`/${locale}/dashboard/`}><FormattedMessage {...localMessages.shsatDashboardLink} /></a>
        </div>
        <div> 
          <h2 className={style.page_heading}>
            <FormattedMessage
              {...localMessages.shsatPageHeading}
              values={{
                studentName: titleCase(student_data.first_name + ' ' + student_data.last_name),
              }}              
            />
          </h2>
          <br></br>
        </div>       
        <div className="cols results-submission-link">
          <div className="col-8" style={{ paddingLeft: "100px" }}>
            <div>

              <a href={`/${locale}/dashboard/${appId}/submitted`} className="button">
                <div className="button-action-text button-action-text-large">
                <FormattedMessage {...localMessages.shsatViewSubmittedButton} />
                </div>
                <div className="button-action button-action-large"><i className="icon-caret-right" role="presentation"></i></div>
              </a>
            </div>
            <div><br />
            <h2 style={{fontSize: "2.2rem", marginBottom: "10px"}}><FormattedMessage {...localMessages.shsatNextStep} /></h2>
            </div>
          </div>
        </div>
        <div className="cols">
          <div className="col-1 spacer"></div>
          <div className="col-8">
            <p style={{ fontSize: "14px" }}
            dangerouslySetInnerHTML={{ __html: result.next_step_content }}
            ></p>
          </div>
        </div>
        <div className="cols">
          <div className="col-1 spacer"></div>
          <div className="col-8">
            <p style={{ fontSize: "14px" }}><FormattedMessage {...localMessages.shsatPageHelpText} /></p>
          </div>
        </div>
        <div className="cols shs-results-div">
          <div className="col-1 spacer"></div>
          <div className="col-8 offer-recieved">
            {result.offered_program && (
              <div className="basic-card with-shadow">                            
                <FormattedMessage
                  {...localMessages.shsatOfferHeading}
                  values={{
                    schoolName: result.school_name,
                  }}    
                  tagName="h3"
                />

                <table className={style.shsat_score_card}>
                <tbody>
                <tr>
                  <td><FormattedMessage {...localMessages.shsatScoreComposite} /></td>
                  <td className={style.score_value}>{result.composite_score}</td>
                </tr>
                <tr>
                  <td><FormattedMessage {...localMessages.shsatScoreVerbal} /></td>
                  <td className={style.score_value}>{result.verbal_score}</td>
                </tr>
                <tr>
                  <td><FormattedMessage {...localMessages.shsatScoreMath} /></td>
                  <td className={style.score_value}>{result.math_score}</td>
                </tr>
                <tr>
                  <td><FormattedMessage {...localMessages.shsatOfferedGrade} /></td>
                  <td className={style.score_value}>{result.offered_grade}</td>
                </tr>
                </tbody>
                </table>

              </div>
            )}
            {!result.offered_program && (
              <div className="basic-card with-shadow">                
                <FormattedMessage {...localMessages.shsatNoOfferHeading} tagName="h4" />
                <table className={style.shsat_score_card}>
                <tbody>
                <tr>
                  <td><FormattedMessage {...localMessages.shsatScoreComposite} /></td>
                  <td className={style.score_value}>{result.composite_score}</td>
                </tr>
                <tr>
                  <td><FormattedMessage {...localMessages.shsatScoreVerbal} /></td>
                  <td className={style.score_value}>{result.verbal_score}.</td>
                </tr>
                <tr>
                  <td><FormattedMessage {...localMessages.shsatScoreMath} /></td>
                  <td className={style.score_value}>{result.math_score}</td>
                </tr>
                </tbody>
                </table>
              </div>
            )}            
            <div className="cols">
              <div style={{marginBottom: '20px'}}>
                <div className="results-list__wrapper__block">
                  {
                    result.offer != '' && (
                      <a
                        href={`/${locale}/dashboard/letter/${result.offer}/`}
                        className='button simple'
                        target='_blank'
                      >
                        <FormattedMessage {...localMessages.shsatDownloadLetterButton} />
                      </a>
                    )
                  }
                  {
                    result.offer == '' && (
                      <button className='button simple disabled'>
                        <FormattedMessage {...localMessages.shsatDownloadLetterButton} />
                      </button>
                    )
                  }
                </div>
              </div>
              <br></br>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ schools, filters, user }) => ({
  schools,
  user,
  ...filters,
});

export default compose(
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps),
)(Shsat);